module.exports = __webpack_public_path__ + "img/2012-3.ee5e4685.jpg";